import React from 'react'
import { Button } from '@mui/material'
import PropTypes from 'prop-types'
import styles from './ButtonStyles'

const WideSmallActionButton = (props) => {
  const classes = styles()
  return (
    <Button className={classes.buttonCustom} {...props}>
      {props.children}
    </Button>
  )
}

WideSmallActionButton.propTypes = {
  children: PropTypes.any,
}

export default WideSmallActionButton
